import { inject, Injectable } from '@angular/core';
import { firstValueFrom } from 'rxjs';

import { InformationSchemaTableExtended, LayersService } from '@connect-services/src/sdk/api';

@Injectable({
    providedIn: 'root',
})
export class AttributeInformationService {
    private readonly layersService = inject(LayersService);

    public findByKey(infos: InformationSchemaTableExtended[], key: string): InformationSchemaTableExtended | null {
        return infos.find((info: InformationSchemaTableExtended) => info.name === key) ?? null;
    }

    public loadForLayer(layerId: string): Promise<InformationSchemaTableExtended[]> {
        return firstValueFrom(this.layersService.layerControllerGetAttributesInformation({ id: layerId }));
    }
}
